var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 7.33317L8.6665 7.33317L8.6665 3.33317C8.6665 2.9645 8.36784 2.6665 7.99984 2.6665C7.63184 2.6665 7.33317 2.9645 7.33317 3.33317L7.33317 7.33317L3.33317 7.33317C2.96517 7.33317 2.6665 7.63117 2.6665 7.99984C2.6665 8.3685 2.96517 8.6665 3.33317 8.6665L7.33317 8.6665L7.33317 12.6665C7.33317 13.0352 7.63184 13.3332 7.99984 13.3332C8.36784 13.3332 8.6665 13.0352 8.6665 12.6665L8.6665 8.6665L12.6665 8.6665C13.0345 8.6665 13.3332 8.3685 13.3332 7.99984C13.3332 7.63117 13.0345 7.33317 12.6665 7.33317Z",
    fill: "#AA0061"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8396_1537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 7.33317L8.6665 7.33317L8.6665 3.33317C8.6665 2.9645 8.36784 2.6665 7.99984 2.6665C7.63184 2.6665 7.33317 2.9645 7.33317 3.33317L7.33317 7.33317L3.33317 7.33317C2.96517 7.33317 2.6665 7.63117 2.6665 7.99984C2.6665 8.3685 2.96517 8.6665 3.33317 8.6665L7.33317 8.6665L7.33317 12.6665C7.33317 13.0352 7.63184 13.3332 7.99984 13.3332C8.36784 13.3332 8.6665 13.0352 8.6665 12.6665L8.6665 8.6665L12.6665 8.6665C13.0345 8.6665 13.3332 8.3685 13.3332 7.99984C13.3332 7.63117 13.0345 7.33317 12.6665 7.33317Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8396_1537)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.dd88620ae0fd56c8872eeb03903a2b25.svg";
export { ForwardRef as ReactComponent };